import { render, staticRenderFns } from "./postItemForm.vue?vue&type=template&id=5536755a&"
import script from "./postItemForm.vue?vue&type=script&lang=js&"
export * from "./postItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports